<template>
  <div class="forget_password">
    <div class="password_content">
      <h3>找回密码</h3>
      <form action="">
        <input v-model="postData.loginName" type="text" placeholder="hecoos账号/邮箱/手机号">
        <div class="get_code">
          <input v-model="postData.verifyCode" class="code_inp" type="text" placeholder="验证码">
          <button :disabled="!isAccountValid || isCountingDown" class="code_btn" @click="getCode">{{ isCountingDown ?
            `${countdown}s后重试` : "获取验证码" }}</button>
        </div>
        <input v-model="postData.password" type="password" placeholder="设置密码">
        <input v-model="postData.confirmPassword" type="password" placeholder="确认密码">
        <button type="submit" @click="handleSubmit" :disabled="!isButtonEnabled">提交</button>
      </form>
      <p><span @click="jumpTo('/')">回首页</span>丨<span @click="jumpTo('/Register')">去注册</span></p>
    </div>
  </div>
</template>
<script>
import { getModifyPasswordCaptcha, modifyPassword } from "@/api/api";
import { Message } from "element-ui";
export default {
  name: "mobile_forgetPassword",
  data() {
    return {
      postData: {
        loginName: '',
        password: '',
        confirmPassword: '',
        verifyCode: '',
      },
      isCountingDown: false,
      countdown: 60,
    };
  },
  computed: {
    // 获取验证码前验证
    isAccountValid() {
      const phoneRegex = /^1[3-9]\d{9}$/;
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return phoneRegex.test(this.postData.loginName) || emailRegex.test(this.postData.loginName);
    },
    // 提交前校验
    isButtonEnabled() {
      return (
        this.postData.loginName &&
        this.postData.verifyCode &&
        this.postData.password &&
        this.postData.confirmPassword &&
        this.postData.password === this.postData.confirmPassword
      );
    }
  },
  methods: {
    jumpTo(url) {
      this.$router.push(url);
    },
    // 获取验证码
    getCode() {
      getModifyPasswordCaptcha(this.postData).then((res) => {
        if (res.code === 200) {
          Message.success(res.message);
          this.startCountdown();
        } else {
          Message.error(res.message);
        }
      });
    },
    // 获取验证码倒计时
    startCountdown() {
      this.isCountingDown = true;
      let timer = setInterval(() => {
        this.countdown--;
        if (this.countdown === 0) {
          clearInterval(timer);
          this.isCountingDown = false;
          this.countdown = 60;
        }
      }, 1000);
    },
    // 提交表单
    handleSubmit() {
      modifyPassword(this.postData).then((res) => {
        // console.log(res)
        if (res.code === 200) {
          Message.success(res.message);
          localStorage.clear();
          setTimeout(() => {
            this.$router.push('/login')
          }, 1000);
        } else {
          Message.error(res.message);
        }
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.forget_password {
  width: 100%;
  height: 100vh;
  background: url("https://download.hecoos.com/enlightv/2025-19/b946e97c082f040312c95a399d847c29.png");
  background-size: cover;
  background-repeat: no-repeat;
  object-fit: cover;
  // background-color: #d0cad4;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 30px;

  .password_content {
    width: 100%;
    max-width: 370px;
    background-color: #222222;
    padding: 20px;
    border-radius: 6px;
    text-align: center;

    h3 {
      font-size: 24px;
      color: #fff;
      margin-bottom: 15px;
    }

    input {
      display: block;
      width: 100%;
      font-size: 14px;
      padding: 8px;
      border-radius: 6px;
      border: none;
      // margin: 0 10px;
      margin-bottom: 10px;
      background-color: #333333;
      color: #757575;

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    .get_code {
      position: relative;

      .code_inp {
        margin-bottom: 10px;
      }

      .code_btn {
        position: absolute;
        top: 0;
        right: 0;
        width: 40% !important;
        background-color: #333333 !important;
        color: #757575 !important;
        margin: 0;
        font-size: 14px;
        
      }
    }

    button {
      display: block;
      width: 100%;
      font-size: 18px;
      margin-top: 15px;
      padding: 8px;
      border: none;
      border-radius: 6px;
    }

    p {
      font-size: 16px;
      color: #fff;
      margin-top: 10px;
    }
  }
}
</style>